// src/components/PrivateRoute.js - VERSION CORRIGÉE ET SIMPLIFIÉE

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom'; 

// NOTE IMPORTANTE : Nous avons retiré l'import de SocketProvider 
// car il est déjà géré dans App.js et causait un conflit de DOM.

// Fonction utilitaire pour vérifier l'authentification
const isAuthenticated = () => {
    // Votre logique reste inchangée : vérifier la présence du jeton
    return localStorage.getItem('token') !== null;
};

const PrivateRoute = ({ children }) => {
    const location = useLocation(); 
    const auth = isAuthenticated();
    
    // 1. Si l'utilisateur n'est pas authentifié (Non)
    if (!auth) {
        // Sauvegarder l'URL complète pour la redirection post-connexion
        const fullPath = location.pathname + location.search; 

        return (
            <Navigate 
                to="/login" // Rediriger vers la page de connexion
                state={{ from: fullPath }} // Sauvegarder l'URL souhaitée (y compris les paramètres de parrainage)
                replace 
            />
        );
    }

    // 2. Si l'utilisateur est authentifié (Oui)
    // Rendre UNIQUEMENT les enfants (le composant de la page).
    // Les fournisseurs de contexte (SocketProvider, ThemeProvider, etc.) 
    // sont déjà au-dessus dans App.js.
    return children;
};

export default PrivateRoute;